import { CollapseProps } from "antd"
import { ReactNode } from "react"

type SupportFaqItem = NonNullable<CollapseProps["items"]>[number]
type SupportFaqKey = "1" | "2" | "3" | "4" | "5" | "6"

interface CreateSupportFaqItemsParams {
  onOpenMobileApp: () => void
  subscriptionChildren?: ReactNode
  telegramUrl?: string
  itemProps?: Partial<Record<SupportFaqKey, Partial<SupportFaqItem>>>
}

export const createSupportFaqItems = ({
  onOpenMobileApp,
  subscriptionChildren,
  telegramUrl = "https://t.me/loyalty_plus_support",
  itemProps = {},
}: CreateSupportFaqItemsParams): CollapseProps["items"] => {
  const items: CollapseProps["items"] = [
    {
      id: "supp2",
      key: "1",
      label: "Зачем нужна подписка?",
      children: subscriptionChildren ?? (
        <p>
          Подписка дает преимущества описанные в разделе "Управление подпиской" и
          возможность получать больший процент кешбэка и скидку в магазине.
        </p>
      ),
    },
    {
      id: "supp3",
      key: "2",
      label: "Где я могу тратить кешбэк?",
      children: (
        <p>
          К вашему вниманию представлен магазин, в котором вы можете приобретать 
          товары по лучшим ценам в сетевых магазинах (М.Видео, Ситилинк, Эльдорадо), 
          оплачивая до <b>50% стоимости</b> бонусными рублями, а оставшуюся сумму — настоящими рублями.
        </p>
      ),
    },
    {
      id: "supp4",
      key: "3",
      label: "Могу ли я оплатить услуги бонусами?",
      children: (
        <p>
          Накопленный кешбэк можно тратить только в магазине <b>ПЛЮС</b>. Их
          невозможно потратить на частичную или полную оплату стрижки в филиалах
          партнеров.
        </p>
      ),
    },
    {
      id: "supp5",
      key: "4",
      label: "Для кого эта программа?",
      children: (
        <p>
          Поскольку основным элементом лояльности является кешбэк за оплаченные услуги,
          участниками программы могут быть только активные клиенты филиалов партнеров (TOPGUN, FIDEL, Персона).
        </p>
      ),
    },
    {
      id: "supp6",
      key: "5",
      label: "Мобильное приложение",
      children: (
        <p>
          <a
            href="#"
            onClick={(ev) => {
              ev.preventDefault()
              onOpenMobileApp()
            }}
          >
            Инструкция
          </a>
        </p>
      ),
    },
    {
      id: "supp7",
      key: "6",
      label: "Куда обратиться с вопросами?",
      children: (
        <p>
          При возникновении любых проблем связанных с работой сайта, просим
          незамедлительно обращаться к нам{" "}
          <a href={telegramUrl} target="_blank">
            напрямую в Telegram
          </a>
        </p>
      ),
    },
  ]

  return items.map((item) => ({
    ...item,
    ...(itemProps[item.key as SupportFaqKey] || {}),
  }))
}
